import React from 'react';
import { number, object, shape } from 'prop-types';
import { Table } from '@devexpress/dx-react-grid-material-ui';

import ContextMenu from './ContextMenu';

const ActionCell = ({ row, tableRow, ...props }) => (
    <Table.Cell tableRow={tableRow} {...props}>
        <ContextMenu sensor={row} rowId={tableRow.rowId} />
    </Table.Cell>
);

ActionCell.defaultProps = {
    row:      {},
    tableRow: {
        rowId: 0
    }
};

ActionCell.propTypes = {
    row:      object,
    tableRow: shape({
        rowId: number
    })
};

export default ActionCell;
